/* EV Product Showcase - sdilene chovani pro celou rodinu sekci ev-ps-*.
   Pouzito napric vsemi "premium microsite" strankami (GT2RS je pilot, dalsi modely
   pouziji stejne assets/ev-showcase.js + assets/ev-showcase.css, jen jiny obsah sekci). */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll ----
     [data-reveal] elements are fully visible by default (see CSS) - JS only ever ADDS
     the temporary "ps-pre" hidden state right before observing. If this script fails to
     load/run for any reason (network, ad-block, JS error, missing include on a page),
     content simply has no fade-in animation instead of staying invisible forever. */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (!reduceMotion && 'IntersectionObserver' in window && revealEls.length) {
    revealEls.forEach(function (el) { el.classList.add('ps-pre'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---- Parallax (skipped entirely for reduced-motion users) ---- */
  var parallaxEls = reduceMotion ? [] : Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  var ticking = false;
  function applyParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
      var rect = el.getBoundingClientRect();
      var center = rect.top + rect.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (center * speed * -1).toFixed(1) + 'px,0)';
    });
    ticking = false;
  }
  function onScroll() {
    if (!ticking && parallaxEls.length) {
      window.requestAnimationFrame(applyParallax);
      ticking = true;
    }
  }
  if (parallaxEls.length) {
    window.addEventListener('scroll', onScroll, { passive: true });
    applyParallax();
  }

  /* ---- Sticky mini buy-bar: se objevi, jakmile zmizi hero ---- */
  var hero = document.querySelector('[data-ps-hero]');
  var bar = document.querySelector('[data-ps-stickybar]');
  if (hero && bar && 'IntersectionObserver' in window) {
    var barIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    barIo.observe(hero);
  }

  /* ---- Horizontalni galerie: mysi drag pres scroll-snap pas ---- */
  document.querySelectorAll('[data-ps-drag]').forEach(function (track) {
    var isDown = false, startX = 0, startScroll = 0;
    track.addEventListener('pointerdown', function (e) {
      isDown = true; startX = e.clientX; startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      track.addEventListener(ev, function () { isDown = false; track.classList.remove('is-dragging'); });
    });
  });

  /* ---- Pridat do kosiku (funguje i bez JS - form ma realnou action/method) ---- */
  document.querySelectorAll('[data-ps-buy-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btns = form.querySelectorAll('button[type="submit"]');
      btns.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: form.elements['id'].value, quantity: 1 }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        window.location.href = '/cart';
      }).catch(function () {
        form.submit(); /* fallback na klasicky POST /cart/add */
      });
    });
  });
})();
